export const theme = {
  name: 'auth-theme',
  tokens: {
  colors: {
    brand: {
    primary: {
      value: '#232f3e',  // AWS dark blue
    },
    secondary: {
      value: '#ff9900'  // AWS orange
    }
    }
  },
  components: {
    authenticator: {
    router: {
      borderWidth: '0',
      boxShadow: 'none',
      backgroundColor: 'transparent',
      width: '100%',
      maxWidth: '24rem'
    },
    container: {
      backgroundColor: 'white',
      padding: '2rem',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
    },
    footer: {
      paddingTop: '1rem',
      paddingBottom: '1rem',
      textAlign: 'center'
    }
    },
    field: {
    label: {
      color: '#545b64',
      fontSize: '14px',
      fontWeight: '500',
      marginBottom: '4px'
    },
    control: {
      borderColor: '#e9ebed',
      borderWidth: '1px',
      borderRadius: '4px',
      color: '#16191f',
      backgroundColor: 'white',
      _focus: {
      borderColor: '#047d95',
      boxShadow: '0 0 0 2px rgba(4, 125, 149, 0.2)'
      },
      _hover: {
      borderColor: '#047d95'
      }
    }
    },
    button: {
    backgroundColor: '#047d95',
    borderRadius: '4px',
    color: '#16191f',
    fontSize: '14px',
    fontWeight: '500',
    _hover: {
      backgroundColor: '#033f4c',
      color: 'white'
    },
    _active: {
      backgroundColor: '#033f4c'
    }
    }
  }
  }
};